var klaviyo = klaviyo || [];
klaviyo.init({
        account: "ShZuA4",
        list: "XLvDvf",
  platform: "shopify"
});
klaviyo.enable("backinstock",{ 
trigger: {
  //product_page_text: "Notify Me When Back In Stock",
  product_page_text: "JOIN THE WAITLIST",
  product_page_class: "btn--primary",
  product_page_text_align: "center",
  product_page_margin: "0 0 33px 0",
        replace_anchor: true
},
modal: {
 headline: "{product_name}",
 body_content: "Sign up and we’ll let you know when it’s available - ASAP.",
 email_field_label: "Email",
 button_label: "JOIN THE WAITLIST",
 subscription_success_label: "You're in! We'll let you know when it's back.",
 footer_content: '',
 additional_styles: "@import url('https://use.typekit.net/qkx8xmi.css');",
 font_family: "Sofia-Pro",
 drop_background_color: "#000",
 background_color: "#fff",
 text_color: "#000",
 button_text_color: "#fff",
 button_background_color: "#483349",
 close_button_color: "#ccc",
 error_background_color: "#fcd6d7",
 error_text_color: "#C72E2F",
 success_background_color: "#483349",
 success_text_color: "#fff"
}
});